import React from 'react';

// helpers
import {useTranslation} from 'react-i18next';
import {getDetailedFields, getSummaryFields} from './helpers';

// components
import {ProgressCircle} from '../../ProgressCircle';
import {LabelContentHorizontal} from '../../LabelContentHorizontal';
import {CardBorder} from '../../CardBorder';

// styles
import {
  CardColumn,
  Separator,
  StyledLinkPrimary,
  DesktopWrapper,
  DesktopContent,
  DesktopCircleWrapper,
} from '../CardDetails-styles';
import {Subtitle} from '../../../styles';

// types
import {CardDetailsLoanProps} from './CardDetailsLoan';

// Number of items in the first column
const FIRST_COLUMN_ITEMS = 4;

const CardDetailsLoanDesktop = ({loan, variant}: CardDetailsLoanProps) => {
  const {t} = useTranslation();

  /**
   * Render the fields based on the variant
   */
  const renderFields = () => {
    const fields =
      variant === 'detailed'
        ? getDetailedFields(loan, t)
        : getSummaryFields(loan, t);
    const [firstColumnFields, secondColumnFields] = [
      fields.slice(0, FIRST_COLUMN_ITEMS),
      fields.slice(FIRST_COLUMN_ITEMS),
    ];

    return (
      <>
        <CardColumn>
          {firstColumnFields.map(({label, content}) => (
            <LabelContentHorizontal
              key={label}
              label={label}
              content={content}
              isFullWidth
            />
          ))}
        </CardColumn>
        <Separator />
        <CardColumn>
          {secondColumnFields.map(({label, content}) => (
            <LabelContentHorizontal
              key={label}
              label={label}
              content={content}
              isFullWidth
            />
          ))}
          {variant === 'summary' && (
            <StyledLinkPrimary href={`/loans/${loan.id}`}>
              {t('dashboard_seeMore')}
            </StyledLinkPrimary>
          )}
        </CardColumn>
      </>
    );
  };

  return (
    <CardBorder variant="white" hasShadow>
      <DesktopWrapper>
        {variant === 'summary' && (
          <Subtitle bold="bold">
            {t('loan_loanNumber_number', {
              number: loan.loanNumber,
            })}
          </Subtitle>
        )}
        <DesktopContent>
          {renderFields()}
          <Separator />
          <DesktopCircleWrapper>
            <ProgressCircle percentage={loan.percentagePaid} />
          </DesktopCircleWrapper>
        </DesktopContent>
      </DesktopWrapper>
    </CardBorder>
  );
};

export default CardDetailsLoanDesktop;
